/**
 * Upload an image to DigitalOcean Spaces via the presigned-URL Function.
 * Returns the public CDN URL (drop-in replacement for old response.data.result).
 */

function parseMetaResponse(raw) {
  // DO Functions may return the payload directly or wrap it as { body: "<json>" }
  if (raw && raw.uploadUrl && raw.cdnUrl) {
    return raw
  }
  if (raw && typeof raw.body === 'string') {
    return JSON.parse(raw.body)
  }
  if (raw && raw.body && raw.body.uploadUrl) {
    return raw.body
  }
  throw new Error('Unexpected upload URL response')
}

export async function uploadImageBlob(fileOrBlob, filename, contentType) {
  const endpoint = process.env.VUE_APP_UPLOAD_URL
  if (!endpoint) {
    throw new Error('VUE_APP_UPLOAD_URL is not configured')
  }

  const metaRes = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      filename: filename || 'image.jpg',
      contentType: contentType || 'application/octet-stream'
    })
  })

  if (!metaRes.ok) {
    const text = await metaRes.text().catch(() => '')
    throw new Error(`Failed to get upload URL (${metaRes.status}): ${text}`)
  }

  const meta = parseMetaResponse(await metaRes.json())
  if (meta.error) {
    throw new Error(meta.error)
  }

  const headers = Object.assign(
    {
      'Content-Type': contentType || 'application/octet-stream',
      'x-amz-acl': 'public-read'
    },
    meta.requiredHeaders || {}
  )

  const putRes = await fetch(meta.uploadUrl, {
    method: 'PUT',
    headers,
    body: fileOrBlob
  })

  if (!putRes.ok) {
    const text = await putRes.text().catch(() => '')
    throw new Error(`Failed to upload file (${putRes.status}): ${text}`)
  }

  return meta.cdnUrl
}

export async function uploadImageDataUrl(dataUrl, filename) {
  const match = /^data:(image\/[a-zA-Z0-9.+-]+);base64,/.exec(dataUrl)
  const contentType = match ? match[1] : 'image/jpeg'
  const blob = await fetch(dataUrl).then((r) => r.blob())
  const ext = (contentType.split('/')[1] || 'jpg').replace('jpeg', 'jpg')
  const name = filename && filename.includes('.')
    ? filename
    : `${filename || 'image'}.${ext}`
  return uploadImageBlob(blob, name, contentType)
}
